import { render, staticRenderFns } from "./digital-human-avatar-grid.vue?vue&type=template&id=03141fb6&scoped=true"
import script from "./digital-human-avatar-grid.vue?vue&type=script&lang=js"
export * from "./digital-human-avatar-grid.vue?vue&type=script&lang=js"
import style0 from "./digital-human-avatar-grid.vue?vue&type=style&index=0&id=03141fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03141fb6",
  null
  
)

export default component.exports